/* eslint-disable space-infix-ops */
import '../scss/doris-video-player.scss';
import BaseComponent from 'foundation/base-component';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

import EndeavorPlayer from './components/endeavor-player';

class EndeavorPlayerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.render();
    }

    render() {
        ReactDOM.render(
            <Fragment>
                <EndeavorPlayer content={this.options} />
            </Fragment>,
            this.element
        );
    }
}

export default EndeavorPlayerComponent;
